var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("m-groups", {
        attrs: {
          active: _vm.isGroupsModalActive,
          "modal-groups": _vm.modalGroups,
        },
        on: {
          close: _vm.closeGroupsModal,
          updatePostGroups: _vm.updatePostGroups,
        },
      }),
      _c("m-new-position", {
        attrs: { active: _vm.isNewPositionModalActive },
        on: {
          close: _vm.closeNewPositionModal,
          saved: _vm.onCreateNewPosition,
        },
      }),
      _c("div", { staticClass: "layout positions" }, [
        _c(
          "div",
          { staticClass: "positions__stats" },
          [
            _vm._l(_vm.postsStats, function (post) {
              return [
                post.countWorkers > 0
                  ? _c(
                      "div",
                      { key: post.name, staticClass: "positions__stats__post" },
                      [
                        _c(
                          "div",
                          { staticClass: "positions__stats__post__title" },
                          [_vm._v(_vm._s(post.name))]
                        ),
                        _c(
                          "div",
                          { staticClass: "positions__stats__post__count" },
                          [_vm._v(_vm._s(post.countWorkers))]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
        _c("div", { staticClass: "layout-header" }, [
          _c("div", { staticClass: "layout-title" }, [_vm._v("Должности")]),
          _c("div", { staticClass: "layout-header-actions" }, [
            _c(
              "div",
              { staticClass: "layout-header-action" },
              [
                _c("c-button", {
                  attrs: {
                    size: "small",
                    icon: {
                      icon: "bookmark",
                      activeColor: "white",
                    },
                    tooltip: {
                      text: "Добавить в закладки",
                      activeText: "Убрать из закладок",
                    },
                    "active-color": "blue",
                    active: _vm.bookmark,
                  },
                  on: {
                    click: function ($event) {
                      _vm.bookmark = !_vm.bookmark
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "layout-header-action" },
              [
                _c("c-button", {
                  attrs: {
                    responsive: true,
                    size: "small",
                    label: "Настроить группы и категории",
                    icon: { icon: "groups", color: "white" },
                  },
                  on: {
                    click: function ($event) {
                      _vm.isGroupsModalActive = true
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "layout-header-action layout-header-action-new-employee",
              },
              [
                _c("c-button-2", {
                  attrs: {
                    size: "small",
                    label: "Новая должность",
                    icon: {
                      icon: "plus",
                      color: "blue",
                    },
                  },
                  on: {
                    click: function ($event) {
                      _vm.isNewPositionModalActive = true
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "layout-header-action layout-header-action-new-employee-mobile",
              },
              [
                _c("c-button-2", {
                  attrs: {
                    size: "small",
                    responsive: "",
                    label: "Новая должность",
                    icon: {
                      icon: "plus",
                      color: "blue",
                    },
                  },
                  on: {
                    click: function ($event) {
                      _vm.isNewPositionModalActive = true
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "positions__fields",
            class: { positions__fields_active: _vm.filtersVisible },
          },
          [
            _c(
              "b-row",
              { attrs: { "align-v": "center", cols: "12" } },
              [
                _vm._l(_vm.globalFilters, function (filter) {
                  return _c(
                    "b-col",
                    {
                      key: filter.name,
                      staticClass: "flex-grow-1",
                      attrs: { sm: "12", md: filter.md, lg: "auto" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "positions__fields-item" },
                        [
                          filter.type === "select"
                            ? _c("c-input", {
                                attrs: {
                                  type: filter.type,
                                  label: filter.label,
                                  checkbox: filter.checkbox,
                                  "checkbox-type": filter.checkboxType,
                                  "checkbox-tooltip": filter.checkboxTooltip,
                                  "checkbox-value": filter.checkboxValue,
                                  multiple: filter.multiple,
                                  searchable: filter.searchable,
                                  placeholder: filter.placeholder,
                                  items: filter.items,
                                },
                                on: { checkboxChange: _vm.inputCheckboxChange },
                                model: {
                                  value: filter.value,
                                  callback: function ($$v) {
                                    _vm.$set(filter, "value", $$v)
                                  },
                                  expression: "filter.value",
                                },
                              })
                            : _vm._e(),
                          filter.type === "text"
                            ? _c("c-input", {
                                attrs: {
                                  type: filter.type,
                                  label: filter.label,
                                  placeholder: filter.placeholder,
                                  clearable: filter.clearable,
                                },
                                model: {
                                  value: filter.value,
                                  callback: function ($$v) {
                                    _vm.$set(filter, "value", $$v)
                                  },
                                  expression: "filter.value",
                                },
                              })
                            : _vm._e(),
                          filter.type === "switcher"
                            ? _c("c-switcher", {
                                attrs: { label: filter.label },
                                model: {
                                  value: filter.value,
                                  callback: function ($$v) {
                                    _vm.$set(filter, "value", $$v)
                                  },
                                  expression: "filter.value",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                _c("b-col", { attrs: { col: "" } }, [
                  _c("div", { staticClass: "positions__fields-actions" }, [
                    _c(
                      "div",
                      { staticClass: "positions__fields-actions-item" },
                      [
                        _c("c-button", {
                          attrs: {
                            label: "Сбросить",
                            disabled:
                              !_vm.$refs.routePositions ||
                              _vm.$refs.routePositions._data.isTableLoad,
                          },
                          on: { click: _vm.resetFilters },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "positions__fields-actions-item" },
                      [
                        _c("c-button", {
                          attrs: {
                            label: "Применить",
                            color: "primary",
                            disabled:
                              !_vm.$refs.routePositions ||
                              _vm.$refs.routePositions._data.isTableLoad,
                          },
                          on: { click: _vm.applyFilters },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "positions__tabs" },
          [
            _c("c-tabs", {
              attrs: {
                items: _vm.tabs,
                "with-routing": "",
                "current-query": _vm.$route.query,
                "with-naming-routing": "positions",
                "naming-param": "code",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "positions__content" },
          [
            _c("router-view", {
              key: _vm.$route.params.code,
              ref: "routePositions",
              attrs: {
                "all-groups": _vm.modalGroups,
                "all-global-filters": _vm.globalFilters,
                "current-path-code": _vm.currentPathCode,
                "enabled-global-filters": _vm.enabledGlobalFilters,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }